<template>
  <v-checkbox
    :class="$style.checkbox"
    :color="color"
    v-bind="$attrs"
    :input-value="value"
    @input="$emit('input', $event)"
    @change="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <template #label>
      <!-- eslint-disable-next-line -->
      <span v-if="label" v-html="label" @click.stop></span>
      <slot v-else />
    </template>
  </v-checkbox>
</template>

<script>
import { get } from 'lodash-es'

export default {
  name: 'BaseCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'black',
    },
  },
  computed: {
    label() {
      return (
        get(this.$slots, 'default[0].text') ||
        get(this.$slots, 'default[0].data.domProps.innerHTML', '')
      )
    },
  },
}
</script>
<style lang="scss" module>
.checkbox {
  line-height: 1;

  :global(.error--text) :not(a) {
    color: var(--red) !important;
  }

  :global(.v-input__control) {
    @supports (width: unset) {
      width: auto;
    }
    width: 100%;
  }

  label {
    margin-left: 1rem;
  }
}
</style>
